import {useEffect, useRef} from 'react';
import fabric from '~/common/canvas/fabric';

const BASE_STEP = 1;
const SHIFT_STEP = 10;

export const Direction = {
  LEFT: 0,
  UP: 1,
  RIGHT: 2,
  DOWN: 3,
};

export const useKeyboardControls = (canvas) => {
  const shiftPressed = useRef(false);
  const leftIntervalRef = useRef(null);
  const rightIntervalRef = useRef(null);
  const upIntervalRef = useRef(null);
  const downIntervalRef = useRef(null);
  const activeObject = canvas?.getActiveObject();

  const moveSelected = (direction) => {
    const stepLength = shiftPressed.current ? SHIFT_STEP : BASE_STEP;

    if (activeObject) {
      switch (direction) {
        case Direction.LEFT:
          activeObject.left -= stepLength;
          break;
        case Direction.UP:
          activeObject.top -= stepLength;
          break;
        case Direction.RIGHT:
          activeObject.left += stepLength;
          break;
        case Direction.DOWN:
          activeObject.top += stepLength;
          break;
        default:
          break;
      }
      activeObject.setCoords();
      canvas?.renderAll();
    }
  };

  useEffect(() => {
    const onKeyDown = (options) => {
      if (options.repeat) return;

      const key = options.which || options.keyCode;

      switch (key) {
        case 16: // Shift
          shiftPressed.current = true;
          break;
        case 37: // Left
          leftIntervalRef.current = setInterval(() => moveSelected(Direction.LEFT), 50);
          break;
        case 38: // Up
          upIntervalRef.current = setInterval(() => moveSelected(Direction.UP), 50);
          break;
        case 39: // Right
          rightIntervalRef.current = setInterval(() => moveSelected(Direction.RIGHT), 50);
          break;
        case 40: // Down
          downIntervalRef.current = setInterval(() => moveSelected(Direction.DOWN), 50);
          break;
        default:
      }
    };

    const onKeyUp = (options) => {
      if (options.repeat) return;

      const key = options.which || options.keyCode;

      switch (key) {
        case 16: // Shift
          shiftPressed.current = false;
          break;
        case 37: // Left
          clearInterval(leftIntervalRef.current);
          break;
        case 38: // Up
          clearInterval(upIntervalRef.current);
          break;
        case 39: // Right
          clearInterval(rightIntervalRef.current);
          break;
        case 40: // Down
          clearInterval(downIntervalRef.current);
          break;
        default:
      }
    };

    fabric.util.addListener(document.body, 'keydown', onKeyDown);
    fabric.util.addListener(document.body, 'keyup', onKeyUp);

    return () => {
      fabric.util.removeListener(document.body, 'keydown', onKeyDown);
      fabric.util.removeListener(document.body, 'keyup', onKeyUp);
    };
  }, [canvas, canvas?.getObjects()?.length]);
};
